<template>
    <div class="container">
        <mc-tag
            v-for="(tag, index) in skuSearchTermsValue"
            :key="index"
            :disable-transitions="false"
            :closable="closable"
            @close="handleCloseTag(tag)"
        >
            {{ tag }}
        </mc-tag>

        <div v-if="mode === 'view' && skuSearchTermsValue && !skuSearchTermsValue.length">
            --
        </div>

        <el-input
            v-if="searchTermsInputVisible && mode === 'edit'"
            ref="saveTagInput"
            v-model="onceSearchTermsInputValue"
            style="width: 180px"
            :maxlength="onceInputMaxLength"
            @keyup.enter.native="handleConfirmInput"
            @blur="handleConfirmInput"
        />
        <mc-button
            v-else-if="mode === 'edit'"
            class="button-new-tag"
            size="small"
            :disabled="disabled || searchTermsInputValue.length >= allLimit"
            @click="handleShowInput"
        >
            + 新建搜索词
        </mc-button>

        <word-count
            v-if="mode === 'edit'"
            :value="searchTermsInputValue"
            :limit="allLimit"
        />
    </div>
</template>

<script>
import WordCount from 'components/WordCount';

export default {
    components: {
        WordCount,
    },
    props: {
        // 父组件传入的数组
        value: {
            type: [String, Array],
            default: () => ([]),
        },
        mode: {
            type: String,
            // edit 模式可以填词；view 模式不可以填词
            // 老品扩城时不允许修改 sku 搜索词，设置为 view 模式
            default: 'edit',
        },
        allLimit: {
            type: [String, Number],
            default: 100,
        },
        singleLimit: {
            type: [String, Number],
            default: 10,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            onceSearchTermsInputValue: '', // 每次输入的sku搜索词-字符串
            searchTermsInputValue: '', // sku搜索词-字符串（保存）
            searchTermsInputVisible: false, // sku搜索词input框是否可见
        };
    },
    computed: {
        onceInputMaxLength() {
            const {
                searchTermsInputValue, allLimit, singleLimit,
            } = this;
            if (singleLimit + searchTermsInputValue.length <= allLimit - 1) {
                // 不超出时限制输入的字数为10
                return singleLimit;
            } else {
                // 要超出时限制为可以输入的字数
                // 1代表一个逗号
                return allLimit - 1 - searchTermsInputValue.length;
            }
        },
        closable() {
            const { mode, disabled } = this;
            return mode === 'edit' && !disabled;
        },
        skuSearchTermsValue() {
            const { value } = this;
            if (Array.isArray(value) && value.length) {
                return value;
            } else if (typeof value === 'string' && value.length) {
                return value.split(',');
            } else {
                return [];
            }
        },
    },
    watch: {
        skuSearchTermsValue: {
            handler() {
                this.handleCountAllWords();
            },
            deep: true,
        },
    },
    created() {
        // 加载时计数
        this.handleCountAllWords();
    },
    mounted() {},
    methods: {
        // 计算搜索词的字数 & 要提交的数据 （包括词之间的连接符-逗号）
        handleCountAllWords() {
            this.searchTermsInputValue = this.skuSearchTermsValue.join(',');
        },
        // 删除时抛出save事件
        handleCloseTag(tag) {
            this.skuSearchTermsValue.splice(this.skuSearchTermsValue.indexOf(tag), 1);
            this.handleCountAllWords();
            if (this.mode === 'edit') this.$emit('save', this.searchTermsInputValue);
        },
        handleShowInput() {
            this.searchTermsInputVisible = true;
            this.$nextTick(() => {
                if (this.$refs.saveTagInput) this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 新增时抛出save事件
        handleConfirmInput() {
            const inputValue = this.onceSearchTermsInputValue;
            if (inputValue) {
                // 将中英文逗号都换成英文逗号
                inputValue.replace(/[\uff0c]/g, ',').split(',').forEach((item) => {
                    // 空字符串不计入
                    if (item.trim()) this.skuSearchTermsValue.push(item.trim());
                });
            }
            this.handleCountAllWords();
            this.searchTermsInputVisible = false;
            this.onceSearchTermsInputValue = '';
            if (this.mode === 'edit') this.$emit('save', this.searchTermsInputValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    /deep/ .mtd-tag {
        margin-right: 5px;
    }
}
</style>
